export const OPTIONS = {
    DEBUG_ON: 'OPTIONS/DEBUG/ON',
    DEBUG_OFF: 'OPTIONS/DEBUG/OFF'
};
